import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

export interface ProductCardSpec {
  ean: string;
  brand: string;
  model: string;
  dimensions: string;
  imageUrl?: string;
  pricePerUnit: number;
  currency: string;
  stockAvailable: number;
  efficiency?: string;
  wetGrip?: string;
  noiseLevel?: number;
  season?: string;
  offerId?: string;
  productId?: number;
  providerName?: string;
  deliveryDays?: number;
}

@Component({
  selector: 'app-chat-product-card',
  templateUrl: './chat-product-card.component.html',
  styleUrls: ['./chat-product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatProductCardComponent implements OnChanges {
  @Input({ required: true }) spec!: string;
  @Output() readonly purchase = new EventEmitter<string>();

  product: ProductCardSpec | null = null;
  quantity = 2;
  fallbackRaw: string | null = null;
  imageError = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.imageError = false;
    try {
      this.product = JSON.parse(this.spec) as ProductCardSpec;
      this.fallbackRaw = null;
    } catch {
      this.fallbackRaw = this.spec;
      this.product = null;
    }
  }

  get totalPrice(): string {
    if (!this.product) return '0';
    return (this.product.pricePerUnit * this.quantity).toFixed(2);
  }

  get maxQuantity(): number {
    return this.product?.stockAvailable ?? 20;
  }

  increment(): void {
    if (this.quantity < this.maxQuantity) {
      this.quantity++;
      this.cdr.markForCheck();
    }
  }

  decrement(): void {
    if (this.quantity > 1) {
      this.quantity--;
      this.cdr.markForCheck();
    }
  }

  onBuy(): void {
    if (!this.product) return;
    const msg = `Confirmo: quiero comprar ${this.quantity} unidades del ${this.product.brand} ${this.product.model} (EAN: ${this.product.ean}) a ${this.product.pricePerUnit} ${this.product.currency}/ud — total ${this.totalPrice} ${this.product.currency}`;
    this.purchase.emit(msg);
  }

  onImageError(): void {
    this.imageError = true;
    this.cdr.markForCheck();
  }
}
